export default __webpack_public_path__ + "static/media/nature.45ea1e1b.png";